import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        spaceBetween: 16,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: `.image-slider-swiper-button-next-${sliderIdentifier}`,
            prevEl: `.image-slider-swiper-button-prev-${sliderIdentifier}`
        },
        pagination: {
            el: `.swiper-pagination-${sliderIdentifier}`,
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' + '<span class="sep"></span>' + '<span class="' + totalClass + '"></span>';
            }
        },
    });
}

const allSliders = $('.simple-image-slider-type-3');

allSliders.each((index, element) => buildSwiperSlider(element));